export default __webpack_public_path__ + "static/media/sushi-box-kaviar.c7d9e462.jpg";